module.exports = __webpack_public_path__ + "img/tractive__logo.c5ee7b42.png";